var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center"},[_c('b-progress',{staticClass:"w-75 mx-auto",attrs:{"value":_vm.showCurrent,"max":_vm.max}}),_vm._v(" "),_c('p',{staticClass:"h3"},[_vm._v(_vm._s(_vm.showCurrent)+" / "+_vm._s(_vm.max))])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ecf819aa","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ProgressBar.vue
// module id = 578
// module chunks = 0